










import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import DailyPlanningData from "../../models/DailyPlanningData";
import PlanningEntryListEntry from "../../models/planningEntry/PlanningEntryListEntry";
import {
	getFirstOfMonth,
	getISO8601DayIndex,
	getLastOfMonth,
	isSameDay,
	toISODateString
} from "@/helpers/functions_asi";
import PlanningEntryListFilter from "../../models/planningEntry/PlanningEntryListFilter";
import PaginatedResponse from "../../models/PaginatedResponse";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import DailyOverview from "@/components/planning/DailyOverview.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import OrderSimple from "@/models/order/OrderSimple";

@Component({
	components: {AsiContentContainer, DailyOverview}
})
export default class MonthlyOverview extends Vue {

	@Prop({type: Object, required: true})
	public order!: OrderSimple;

	@Prop({type: Date, required: true})
	public date!: Date;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	private monthData: DailyPlanningData[] = [];
	private planningEntries: PlanningEntryListEntry[] = [];
	private dateFrom: Date | null = null;
	private dateTo: Date | null = null;
	private skippedDaysStart: number = 0;
	private changingMonth: boolean = false;

	public mounted(): void {
		this.setDateBoundaries();
		this.fetchData();
	}

	@Emit('planningEntriesChanged')
	public planningEntriesChanged(): void {
		this.setDateBoundaries();
		this.fetchData();
	}

	@Emit('loadingChanged')
	public loadingChanged(loading: boolean): boolean {
		return loading;
	}

	private prepareMonthData(): void {
		if (this.dateFrom === null || this.dateTo === null) return;
		this.monthData = [];

		let curDay = new Date(this.dateFrom);
		while (curDay.getMonth() === this.date.getMonth()) {
			const entries = this.planningEntries.filter(e => {
				return isSameDay(new Date(e.date), curDay);
			});
			this.monthData.push(new DailyPlanningData(curDay, entries));

			const newDay = new Date(curDay);
			newDay.setDate(curDay.getDate() + 1);
			curDay = newDay;
		}
	}

	private fetchData(): void {
		if (this.dateFrom === null || this.dateTo === null) return;

		const filter = new PlanningEntryListFilter();
		filter.dateFrom = toISODateString(this.dateFrom);
		filter.dateTo = toISODateString(this.dateTo);

		this.loadingChanged(true);
		this.$orderService.planningEntries(this.order.id, filter, null)
			.then((res: PaginatedResponse<PlanningEntryListEntry>) => {
				this.planningEntries = res.data;
				this.prepareMonthData();
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.changingMonth = false;
				this.loadingChanged(false);
			});
	}

	private setDateBoundaries(): void {
		this.dateFrom = getFirstOfMonth(this.date);
		this.dateTo = getLastOfMonth(this.date);
		this.skippedDaysStart = getISO8601DayIndex(this.dateFrom) - 1;
	}

	@Watch('date')
	private onDateChanged(): void {
		this.changingMonth = true;
		this.setDateBoundaries();
		this.fetchData();
	}

	@Watch('order', {deep: true})
	private onOrderChanged(): void {
	    this.fetchData();
	}

}
